import { IBranchMast } from "../../models/BranchMast";

export const EmptyBranch: IBranchMast = {
    branch_ID: undefined,
    branchName: "",
    branchCode: "",
    brachDescription: "",
    company_ID: 0
}